import { getApprovalTaskList } from '@/api/domain/approvals'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  data() {
    return {
      configData: {
        formData: {
          list: [
            {
              el: 'select',
              itemConfig: {
                label: '审批内容',
                prop: 'bizType',
              },
              elConfig: {
                options: {
                  label: 'name',
                  value: 'code',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '审批状态',
                prop: 'state',
              },
              elConfig: {
                options: {
                  label: 'label',
                  value: 'value',
                  list: [],
                },
              },
            },
            {
              el: 'date-picker',
              itemConfig: {
                // 创建时间区间
                label: '发起时间',
                prop: 'gmtCreate',
              },
            },
            {
              el: 'date-picker',
              itemConfig: {
                // 审批时间区间
                label: '审批时间',
                prop: 'approvalTime',
              },
            },

            {
              el: 'select',
              itemConfig: {
                label: '审批类型',
                prop: 'accessMode',
              },
              elConfig: {
                options: {
                  label: 'label',
                  value: 'value',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '车牌号',
                prop: 'carId',
              },
              elConfig: {
                placeholder: '请输入',
                remote: true,
                clearable: true,
                remoteMethod: this.getCarNoList,
                options: {
                  label: 'plateNo',
                  value: 'id',
                  list: [],
                },
                events: {
                  clear: this.clearCarNoList,
                },
              },
            },
            {
              el: 'input',
              itemConfig: {
                label: '审批ID',
                prop: 'id',
              },
              directives: [{ name: 'number', arg: 'integer', value: 18 }],
            },
          ],
          dealWithSearch: this.dealWithSearch,
          customizeReset: this.m_customizeReset,
        },
        tableData: {
          columns: [
            {
              name: 'id',
              columnProps: {
                label: '审批ID',
                prop: 'id',
              },
              render: ({ row }) => {
                return (
                  <span
                    class="a-hover-link"
                    onClick={() => this.m_detailHandle(row)}
                  >
                    {row.id}
                  </span>
                )
              },
            },
            {
              name: 'bizTypeName',
              columnProps: {
                label: '审批内容',
                prop: 'bizTypeName',
              },
            },
            {
              name: 'originatorName',
              columnProps: {
                label: '发起人',
                prop: 'originatorName',
              },
            },
            {
              name: 'accessMode',
              columnProps: {
                label: '审批类型',
                prop: 'accessMode',
              },
              render: ({ row }) => {
                const findItem = this.m_accessModeOptions.find(
                  (item) => item.value === row.accessMode,
                )
                return <span>{(findItem && findItem.label) || '--'}</span>
              },
            },
            {
              name: 'state',
              columnProps: {
                label: '审批状态',
                prop: 'state',
              },
              render: ({ row }) => {
                const findItem = this.m_stateOptions.find(
                  (item) => item.value === row.state,
                )
                return <span>{(findItem && findItem.label) || '--'}</span>
              },
            },
            {
              name: 'gmtCreate',
              columnProps: {
                label: '发起时间',
                prop: 'gmtCreate',
                width: '180px',
              },
            },
            {
              name: 'approvalTime',
              columnProps: {
                label: '审批时间',
                prop: 'approvalTime',
                width: '180px',
              },
            },
            {
              name: 'approvalDuration',
              columnProps: {
                label: '审批时长',
                prop: 'approvalDuration',
                width: '180px',
              },
            },
            {
              name: 'approverName',
              columnProps: {
                label: '审批人',
                prop: 'approverName',
              },
            },
            {
              name: 'operate',
              columnProps: {
                label: '操作',
                fixed: 'right',
                width: 240,
              },
              maxShowLength: operateMaxShowLength,
              getOperateList: ({ row }) => {
                const optBtns = []
                if (row.accessMode === 2 && row.state === 10) {
                  optBtns.push({
                    name: 'refresh',
                    label: '刷新状态',
                    action: () => this.m_refreshHandle(row),
                  })
                }
                return optBtns
              },
              type: 'operate',
            },
          ],
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getApprovalTaskList,
        },
        isShowDepartment: false,
      },
    }
  },
}
